<template>
    <LeftSidebar v-if="!appData.isMobile">
        <li class="nav-link" v-for="r in pc" :key="r">
            <router-link :to="Links.Url(r.link, r.args)" :title="r.text" :class="[ isSelectUrl(Links.Url(r.link, r.args)) ? 'active' : '' ]">
                <span class="menu-icon" aria-hidden="true">
                    <svg v-if="r.icon === 'icon-dashboard'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/></svg>
                    <svg v-else-if="r.icon === 'icon-user'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="5"/><path d="M20 21a8 8 0 0 0-16 0"/></svg>
                </span>
                <span class="link-name">{{r.text}}</span>
            </router-link>
        </li>
        <!--<li class="nav-link" v-if="type == Enums.MENU_TYPE.MAIN">
            <a href="javascript:void(0)" @click="logout" title="Çıkış">
                <i class="icon icon-left-from-bracket"></i>
                <span class="link-name">Çıkış</span>
            </a>
        </li>-->
    </LeftSidebar>
    <LeftSidebarMobile :items="mobile" :isActive="isSelectUrl" v-else class="consultant-fixed-footer" />
</template>
<script>
    import { Enums } from "@/helpers/enums";
    import { Links } from "@/helpers/links";
    import { appData, C } from "@/helpers/global";

    import LeftSidebar from "@/layouts/_partials/LeftSidebar.vue";
    import LeftSidebarMobile from "@/layouts/_partials/LeftSidebar.mobile.vue";

    export default {
        props: ["type"],
        components: {
            LeftSidebar,
            LeftSidebarMobile,
        },
        data() {
            return {
                pc: [
                    { icon: "icon-dashboard", link: Links.Dashboard, text: "Panelim" },
                    { icon: "icon-user", link: Links.User.Profile, text: "Hesabım" },
                ],
                mobile: [
                    { icon: "icon-user", link: Links.User.Profile, text: "Hesabım" },
                    null,
                    null,
                    null,
                    { icon: "icon-dashboard", link: Links.Dashboard, text: "Panelim", isMain: true },
                ],
            }
        },
        methods: {
            isSelectUrl(link) {
                if(C.Str(this.$route.path) == link)  { return true; } 
                return (C.Str(this.$route.path).indexOf(link.replace(/\/0/g, '')) == 0); 
            }
        },
    };
</script>